<template>
  <a class="home-author-card home-card-frame" :href="author.href">
    <img class="home-author-card__avatar" :src="author.profile_photo" :alt="author.name" loading="lazy" @error="onImageError" />
    <strong>{{ author.name }}</strong>
    <small>{{ compactNumber(author.followers) }} seguidores</small>
  </a>
</template>

<script>
import { compactNumber } from "@/utils/homeMetrics";
import { HOME_AVATAR_FALLBACK, setImageFallback } from "@/utils/homeImageFallbacks";

export default {
  name: "HomeAuthorCard",
  props: {
    author: { type: Object, required: true },
  },
  methods: {
    compactNumber,
    onImageError(event) {
      setImageFallback(event, HOME_AVATAR_FALLBACK);
    },
  },
};
</script>
